<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-list" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Manage Encounters</h4>
                <small style="opacity: 0.8;">
                  <span v-if="encounters.meta && encounters.meta.total">{{ encounters.meta.total }}</span> encounters
                </small>
              </div>
            </div>
            <div class="d-flex" style="gap: 8px;">
              <TodayTasks />
              <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;" @click="encounterform = !encounterform">
                <i class="fe mr-1" :class="encounterform ? 'fe-x' : 'fe-plus'"></i>
                {{ encounterform ? 'Close' : 'Add Code' }}
              </button>
              <button class="btn btn-outline-light btn-sm" style="border-radius: 8px; font-weight: 600;" @click="filterparams = !filterparams">
                <i class="fe fe-filter mr-1"></i> Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Encounter code form -->
          <div v-show="encounterform" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-icon">
                <i class="fe fe-plus" style="font-size: 13px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">Add Encounter Code</h6>
            </div>
            <div class="card-body px-4 py-4">
              <form @submit.prevent="sendCode">
                <div class="form-group">
                  <label class="small font-weight-bold text-secondary">Encounter Code</label>
                  <input type="text" required class="form-control" v-model="string_data" placeholder="EC0/000/000/000" />
                </div>
                <button type="submit" class="btn btn-submit">
                  <i class="fe fe-send mr-1"></i> Submit
                </button>
              </form>
            </div>
          </div>

          <!-- Filter form -->
          <div v-show="filterparams" class="card shadow-sm filter-card mb-4">
            <div class="form-card-header">
              <div class="section-icon">
                <i class="fe fe-filter" style="font-size: 13px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">Filter Encounters</h6>
            </div>
            <div class="card-body px-4 py-4">
              <div class="form-row">
                <div class="form-group col-md-6" v-if="user && user.type == 'nhia'">
                  <label class="small font-weight-bold text-secondary">Select SHIA</label>
                  <select class="form-control" v-model="filter_field.selected_agency">
                    <option :value="state" v-for="state in agencies" :key="state">{{ state.name }}</option>
                  </select>
                </div>

                <div class="form-group col-md-4">
                  <label class="small font-weight-bold text-secondary">Agency ID</label>
                  <input type="text" class="form-control" v-model="filter_field.enrollee" placeholder="ID/XXX/XXXXX" />
                </div>

                <div class="form-group col-md-4" v-if="user && user.type != 'nhia'">
                  <label class="small font-weight-bold text-secondary">Diagnosis</label>
                  <v-select v-model="filter_field.diagnosis" :reduce="(name) => name.id" label="name" :options="diseases" />
                </div>

                <div class="form-group col-md-4" v-if="user && (user.type == 'shis' || user.type == 'employee')">
                  <label class="small font-weight-bold text-secondary">Facility</label>
                  <v-select v-model="filter_field.provider_id" :reduce="(agency_name) => agency_name.id" label="agency_name" :options="visibleProviders" />
                </div>

                <div class="form-group col-md-4" v-if="user && user.type != 'nhia' && !isLgaSupervisor">
                  <label class="small font-weight-bold text-secondary">LGA</label>
                  <select @click="fetchLga" class="form-control" v-model="filter_field.localgovt">
                    <option v-for="lga in lga_states" :key="lga.id" :value="lga.id">{{ lga.local_name }}</option>
                  </select>
                </div>

                <div class="form-group col-md-4" v-if="isLgaSupervisor">
                  <label class="small font-weight-bold text-secondary">LGA</label>
                  <input type="text" class="form-control" :value="lgaName" disabled />
                </div>

                <div class="form-group col-md-4">
                  <label class="small font-weight-bold text-secondary">Sector</label>
                  <select class="form-control" v-model="filter_field.sector">
                    <option :value="sector" v-for="sector in sectors" :key="sector">{{ sector }}</option>
                  </select>
                </div>

                <div class="form-group col-md-3">
                  <label class="small font-weight-bold text-secondary"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                  <input type="date" class="form-control" v-model="filter_field.from" />
                </div>

                <div class="form-group col-md-3">
                  <label class="small font-weight-bold text-secondary"><i class="fe fe-calendar mr-1"></i>End Date</label>
                  <input type="date" class="form-control" v-model="filter_field.to" />
                </div>

                <div class="form-group col-md-3">
                  <label class="small font-weight-bold text-secondary">Confirmed</label>
                  <select class="form-control" v-model="filter_field.is_confirmed">
                    <option value=""></option>
                    <option :value="true">Yes</option>
                    <option :value="0">No</option>
                  </select>
                </div>

                <div class="form-group col-md-3">
                  <label class="small font-weight-bold text-secondary">Rows</label>
                  <select class="form-control" v-model="paginate_value">
                    <option>30</option>
                    <option>100</option>
                    <option>500</option>
                    <option>1000</option>
                    <option>5000</option>
                    <option>10000</option>
                    <option>15000</option>
                    <option>30000</option>
                    <option>50000</option>
                  </select>
                </div>
              </div>

              <div class="d-flex" style="gap: 8px;">
                <button class="btn btn-submit" @click="getEncounters('json')">
                  <i class="fe fe-search mr-1"></i> Apply Filter
                </button>
                <button class="btn btn-outline-secondary" @click="getEncounters('csv')">
                  <i class="fe fe-download mr-1"></i> Export CSV
                </button>
              </div>
            </div>
          </div>

          <!-- Encounters table -->
          <div class="card shadow-sm table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Encounters</h6>
              <span v-if="encounters.meta && encounters.meta.total" class="badge badge-soft-info ml-2">{{ encounters.meta.total }}</span>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead style="background: #f8fafc;">
                  <tr>
                    <th class="table-th">Facility</th>
                    <th class="table-th">Patient</th>
                    <th class="table-th">Phone</th>
                    <th class="table-th">Diagnosis</th>
                    <th class="table-th">Date</th>
                    <th class="table-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="encounter in encounters.data" :key="encounter.id" class="table-row">
                    <td class="py-3 px-4">
                      <span v-if="encounter.provider">{{ encounter.provider.agency_name }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="py-3 font-weight-bold">
                      <span v-if="encounter.enrollee">{{ encounter.enrollee.full_name }}</span>
                    </td>
                    <td class="py-3 text-muted small">
                      <span v-if="encounter.enrollee">{{ encounter.enrollee.phone_number }}</span>
                    </td>
                    <td class="py-3">
                      <span v-if="encounter.diagnosis">{{ encounter.diagnosis.name }}</span>
                    </td>
                    <td class="py-3 text-muted small">{{ encounter.created_at | moment("MMM Do YYYY") }}</td>
                    <td class="py-3 pr-4">
                      <div class="d-flex align-items-center" style="gap: 6px;">
                        <router-link :to="{ path: '/encounter/' + encounter.id }">
                          <button type="button" class="btn btn-sm btn-submit">
                            <i class="fe fe-eye"></i>
                          </button>
                        </router-link>
                        <span v-if="encounter.is_confirmed == true" class="badge badge-soft-success">confirmed</span>
                        <span v-if="encounter.is_confirmed == false" class="badge badge-soft-danger">rejected</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!encounters.data || !encounters.data.length">
                    <td colspan="6" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No encounters. Use the filter to search.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="vld-parent">
            <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import TodayTasks from "@/components/TodayTasks.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SectorsJson from "@/json/sectors.json";
import AgenciesJSON from "@/json/agencies.json";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: { Navbar, Loading, TodayTasks },
  data() {
    return {
      paginate_value: 0,
      agencies: AgenciesJSON,
      user: null,
      isLoading: false,
      fullPage: true,
      encounterform: false,
      filterparams: false,
      diseases: "",
      providers: [],
      string_data: "",
      lga_states: "",
      sectors: SectorsJson,
      encounters: { meta: {}, data: [] },
      filter_field: {
        diagnosis: "",
        provider_id: "",
        enrollee: "",
        localgovt: "",
        selected_agency: "",
        sector: "",
        date: "",
        from: "",
        to: "",
        is_confirmed: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios.get(`/api/v1/auth/diagnosis-agency/${agency.id}`)
      .then((response) => { this.diseases = response.data.data; })
      .catch((error) => { console.error(error); });
  },
  computed: {
    isLgaSupervisor() {
      return !!this.user && this.user.job_title === "LGA Supervisor";
    },
    lgaName() {
      const match = (this.lga_states || []).find((lga) => String(lga.id) === String(this.filter_field.localgovt));
      return match ? match.local_name : "";
    },
    // LGA Supervisors only ever see/pick facilities within their assigned LGA,
    // so the facility dropdown can't be used to see another LGA's encounters.
    visibleProviders() {
      if (!this.isLgaSupervisor) return this.providers;
      // A facility's localgovt is a nested object ({id, local_name, ...}), not a plain id.
      return (this.providers || []).filter((p) => p.localgovt && String(p.localgovt.id) === String(this.user.localgovt));
    },
  },
  methods: {
    getEncounters(format = 'json') {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios.post(`/api/v1/auth/service_summary-agency`, {
        format: format,
        provider_id: this.filter_field.provider_id,
        enrollee: this.filter_field.enrollee,
        diagnosis: this.filter_field.diagnosis,
        localgovt: this.filter_field.localgovt,
        sector: this.filter_field.sector,
        date: this.filter_field.date,
        from: this.filter_field.from,
        to: this.filter_field.to,
        agency_id: this.user.type == "nhia" ? this.filter_field.selected_agency.agency_id : agency.id,
        is_confirmed: this.filter_field.is_confirmed,
        paginate_value: this.paginate_value,
      })
      .then((response) => {
        if (format === 'csv') {
          const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `encounters_${new Date().toISOString().slice(0, 10)}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.$toasted.success("CSV downloaded successfully", { position: "top-center", duration: 3000 });
          this.isLoading = false;
          return;
        }
        this.encounters = response.data;
        this.isLoading = false;
      })
      .catch((error) => {
        console.error(error);
        this.isLoading = false;
      });
    },
    sendCode() {
      if (confirm("Are you sure you want to submit?")) {
        this.isLoading = true;
        this.axios.post(`/api/v1/auth/get-string`, { string_data: this.string_data, agency_id: agency.id })
          .then(() => {
            this.getEncounters('json');
            this.string_data = "";
            this.isLoading = false;
            this.encounterform = false;
            this.$toasted.info("Encounter submitted successfully!", { position: "top-center", duration: 3000 });
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.$toasted.error("Code Error!", { position: "top-center", duration: 3000 });
          });
      }
    },
    getProviders() {
      this.axios.get(`/api/v1/auth/providerAgency/${agency.id}`)
        .then((response) => { this.providers = response.data.data; })
        .catch((error) => { console.error(error); });
    },
    fetchLga() {
      if (this.lga_states == "") {
        this.axios.get(`/api/v1/auth/lga/${agency.state}`)
          .then((response) => { this.lga_states = response.data.data; })
          .catch((error) => { console.error(error); });
      }
    },
  },
  created() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.job_title === "LGA Supervisor") {
      this.filter_field.localgovt = user.localgovt;
    }
    this.fetchLga();
    this.getEncounters();
    this.getProviders();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}
.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.form-card, .filter-card, .table-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-icon {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.table-th {
  font-size: 0.73rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0;
  padding: 12px 16px;
}
.table-row:hover { background: #f8fafc; }
.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 20px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37,99,235,0.15);
}
</style>
